module.exports = __webpack_public_path__ + "img/acaki15.47657dda.jpg";